(function () {
  if (window.productAvailabilityGuardInitialized) return;
  window.productAvailabilityGuardInitialized = true;

  function updateProductAvailability(product, available) {
    if (!product) return;

    var shippingEstimate = product.querySelector('[data-shipping-estimate]');
    if (shippingEstimate) shippingEstimate.hidden = !available;

    var formArea = product.querySelector('[data-product-form-area]');
    if (!formArea) return;

    formArea.dataset.selectedVariantAvailable = String(available);
    formArea.classList.toggle('product-sold-out', !available);

    var stockLevel = formArea.querySelector('[data-stock-level]');
    if (stockLevel) stockLevel.hidden = !available;
  }

  function updateProductsForVariant(variant) {
    if (!variant) return;

    var selector = '[data-variant-id="' + variant.id + '"]';
    var matchedProducts = [];

    document.querySelectorAll(selector).forEach(function (variantElement) {
      var isSelectedOption = variantElement.tagName === 'OPTION' && variantElement.selected;
      var isSelectedInput = variantElement.tagName === 'INPUT'
        && String(variantElement.value) === String(variant.id);

      if (!isSelectedOption && !isSelectedInput) return;

      var product = variantElement.closest('.product--outer');
      if (product && matchedProducts.indexOf(product) === -1) matchedProducts.push(product);
    });

    matchedProducts.forEach(function (product) {
      updateProductAvailability(product, variant.available === true);
    });
  }

  window.addEventListener('shopify-variants:switch-variant', function (event) {
    var variant = event.detail && event.detail.variant;

    window.setTimeout(function () {
      updateProductsForVariant(variant);
    }, 0);
  });

  function getSubmittedVariantState(productForm) {
    var variantElements = productForm.querySelectorAll('[data-variant-id][data-variant-available]');
    if (!variantElements.length) return null;

    var variantField = productForm.querySelector('[name="id"]');
    var variantId = variantField && String(variantField.value || '');
    if (!variantId) return { valid: false, available: false };

    var matchedVariant = Array.prototype.find.call(variantElements, function (variantElement) {
      return String(variantElement.dataset.variantId) === variantId;
    });

    if (!matchedVariant) return { valid: false, available: false };

    var availability = matchedVariant.dataset.variantAvailable;
    if (availability !== 'true' && availability !== 'false') {
      return { valid: false, available: false };
    }

    return {
      valid: true,
      available: availability === 'true'
    };
  }

  document.addEventListener('submit', function (event) {
    if (!(event.target instanceof Element)) return;

    var productForm = event.target.closest('[data-product-form]');
    if (!productForm) return;

    var variantState = getSubmittedVariantState(productForm);
    if (!variantState || (variantState.valid && variantState.available)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);
}());
